// Hook + context for the error toast. Lives outside ErrorToastProvider.tsx
// so that file can satisfy react-refresh/only-export-components by
// exporting only the provider component.

import { createContext, useContext } from 'react';

export interface ErrorToastContextValue {
  /** Show an error toast. Accepts any thrown value — friendly message is derived. */
  showError: (err: unknown, fallback?: string) => void;
  /** Show a generic info / success / warning toast. */
  showMessage: (message: string, severity?: 'info' | 'success' | 'warning') => void;
}

export const ErrorToastContext = createContext<ErrorToastContextValue | undefined>(undefined);

export function useErrorToast(): ErrorToastContextValue {
  const ctx = useContext(ErrorToastContext);
  if (!ctx) throw new Error('useErrorToast must be used within ErrorToastProvider');
  return ctx;
}
